import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { addMessage } from 'store/features/common/flash/actions';
import { messageTypes } from 'store/features/common/flash/builder';
import autoBind from 'react-autobind';
import gql from 'graphql-tag';
import styles from './index.module.scss';
import { DropdownMenu, DropdownItem, DropdownToggle, Dropdown } from 'reactstrap';
import routeGenerators from 'ui/common/routes/generators';
import { NavLink } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import themeConfig from 'ui/theme/config';

import { resultHasErrors, errorsToSingleMessage } from 'utils/graphql-errors';

class Companies extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      dropDownDashboardOpen: false,
      dropDownCandidatesOpen: false,
      dropDownJobsOpen: false,
      notifications: [],
      showBar: false,
    };
  }

  componentDidMount() {
    this.getNotifications();
  }

  async getNotifications() {
    const { client, addMessage } = this.props;

    try {
      const result = await client.query({
        query: gql`
          query getMyNotifications {
            getMyNotifications {
              _id
              type
              read
              notificationAt
              data {
                companyName
                text
              }
            }
          }
        `,
      });

      const { data, errors } = result;
      if (resultHasErrors({ errors })) {
        addMessage({
          kind: messageTypes.danger,
          content: errorsToSingleMessage({ errors }),
        });
      } else {
        this.setState({
          notifications: data.getMyNotifications,
        });
      }
    } catch (error) {
      addMessage({
        kind: messageTypes.danger,
        content: 'Something went wrong',
      });
    }
  }

  toggleDashboardDropdown() {
    this.setState(prevState => ({
      dropDownDashboardOpen: !prevState.dropDownDashboardOpen,
    }));
  }

  toggleJobsDropdown() {
    this.setState(prevState => ({
      dropDownJobsOpen: !prevState.dropDownJobsOpen,
    }));
  }

  toggleCandidatesDropdown() {
    this.setState(prevState => ({
      dropDownCandidatesOpen: !prevState.dropDownCandidatesOpen,
    }));
  }

  toggleNotificationBar() {
    this.setState(prevState => ({
      showBar: !prevState.showBar,
    }));
  }

  async markAsRead(id) {
    const { client, addMessage } = this.props;

    try {
      const result = await client.mutate({
        mutation: gql`
          mutation markNotificationRead($notificationId: [String!]!) {
            markNotificationRead(notificationId: $notificationId) {
              _id
              type
              read
              notificationAt
              data {
                companyName
                text
              }
            }
          }
        `,
        variables: {
          notificationId: [id],
        },
      });

      const { errors } = result;
      if (resultHasErrors({ errors })) {
        addMessage({
          kind: messageTypes.danger,
          content: errorsToSingleMessage({ errors }),
        });
      } else {
        // this.toggleNotificationBar();
        this.getNotifications();
      }
    } catch (error) {
      addMessage({
        kind: messageTypes.danger,
        content: 'Something went wrong',
      });
    }
  }

  renderDesktop() {
    const { companies } = this.props;

    return (
      <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
        <div>
          {companies.length > 1 ? (
            <div className="d-flex">
              <Dropdown
                isOpen={this.state.dropDownDashboardOpen}
                toggle={this.toggleDashboardDropdown}
                className="my-auto pr-4"
              >
                <DropdownToggle>Dashboard</DropdownToggle>
                <DropdownMenu>
                  {companies.map((company, index) => {
                    const isProfilerRun = company.features && company.features.profiler;

                    return (
                      <DropdownItem key={index}>
                        <NavLink
                          exact
                          to={
                            isProfilerRun
                              ? routeGenerators.profiler.details({
                                  id: company.profilerRunId,
                                  section: 'candidates',
                                })
                              : routeGenerators.companies.hiringDashboard({
                                  prettyId: company.prettyId,
                                })
                          }
                        >
                          {company.companyName}
                        </NavLink>
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>

              {/* <Dropdown
                isOpen={this.state.dropDownJobsOpen}
                toggle={this.toggleJobsDropdown}
                className="my-auto pr-4"
              >
                <DropdownToggle>Overview</DropdownToggle>
                <DropdownMenu>
                  {companies.map(
                    (company, index) =>
                      company &&
                      company.features.magicLink && (
                        <DropdownItem key={index}>
                          <NavLink
                            exact
                            to={routeGenerators.companies.edit({
                              prettyId: company.prettyId,
                              section: 'jobs-management',
                            })}
                          >
                            {company.companyName}
                          </NavLink>
                        </DropdownItem>
                      )
                  )}
                </DropdownMenu>
              </Dropdown> */}

              {/* <Dropdown
                isOpen={this.state.dropDownCandidatesOpen}
                toggle={this.toggleCandidatesDropdown}
                className="my-auto pr-4"
              >
                <DropdownToggle>Candidates</DropdownToggle>
                <DropdownMenu>
                  {companies.map(
                    (company, index) =>
                      company &&
                      company.features.magicLink && (
                        <DropdownItem key={index}>
                          <NavLink
                            exact
                            to={routeGenerators.companies.edit({
                              prettyId: company.prettyId,
                              section: 'candidates',
                            })}
                          >
                            {company.companyName}
                          </NavLink>
                        </DropdownItem>
                      )
                  )}
                </DropdownMenu>
              </Dropdown> */}
            </div>
          ) : (
            <span>
              {companies.map((company, index) => {
                const isProfilerRun = company.features && company.features.profiler;

                return (
                  <span key={index} className="d-flex">
                    <NavLink
                      className="pr-4 l-5"
                      exact
                      to={
                        isProfilerRun
                          ? routeGenerators.profiler.details({
                              id: company.profilerRunId,
                              section: 'candidates',
                            })
                          : routeGenerators.companies.hiringDashboard({
                              prettyId: company.prettyId,
                            })
                      }
                    >
                      Dashboard
                    </NavLink>

                    {this.state.notifications.length > 0 && (
                      <div
                        className="pr-4 l-5"
                        style={{ color: 'white', cursor: 'pointer' }}
                        onClick={() => this.toggleNotificationBar()}
                      >
                        Candidates &nbsp;
                        {this.state.notifications.filter(notif => !notif.read).length > 0 && (
                          <div className={styles.oval}>
                            <div className={styles.counter}>
                              {' '}
                              {this.state.notifications.filter(notif => !notif.read).length}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </span>
                );
              })}
            </span>
          )}
          {this.state.showBar && this.renderNotificationBar(this.state.notifications)}
        </div>
      </MediaQuery>
    );
  }

  renderNotificationBar(notifications) {
    return (
      <div className={styles.bar}>
        {notifications.map(notif => (
          <div
            className={styles.perNotif}
            onClick={() => this.markAsRead(notif._id)}
            style={{ backgroundColor: !notif.read ? 'rgba(0, 163, 174, 0.08)' : null }}
          >
            <div className={styles.notification}>Notification</div>
            <div className={styles.notifContent}>{notif.data.text}</div>
          </div>
        ))}
      </div>
    );
  }

  renderMobile() {
    const { companies } = this.props;

    return (
      <MediaQuery className="container-fluid px-0" maxWidth={themeConfig.layout.gridBreakpoints.sm}>
        <div>
          {companies.map((company, index) => (
            <span key={index}>
              <NavLink
                exact
                to={routeGenerators.companies.hiringDashboard({ prettyId: company.prettyId })}
              >
                {company.companyName}
              </NavLink>
            </span>
          ))}
        </div>
      </MediaQuery>
    );
  }

  render() {
    return (
      <div>
        {this.renderDesktop()}
        {this.renderMobile()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  addMessage,
};

export default connect(null, mapDispatchToProps)(withApollo(injectIntl(Companies)));



// WEBPACK FOOTER //
// ./src/ui/app/layout/header/companies.js